"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_HeaderImg = exports.Occ_HeaderButton = exports.Occ_HeaderBackTitleContainer = exports.Occ_Header = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_Header = (0, _styledComponents["default"])('header')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0;\n    box-shadow: ", ";\n    width: 100%;\n    height: 40px;\n    font-family: var(--font-family-primary);\n    color: var(--color-font-base);\n    font-weight: var(--font-weight-bold);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 10px;\n    position: relative;\n    text-align: ", ";\n    background-color: ", ";\n"])), function (_ref) {
  var shadow = _ref.shadow;
  return shadow && 'var(--box-shadow-xs)';
}, function (props) {
  return props.htype === 'back' && 'start';
}, function (_ref2) {
  var backgroundT = _ref2.backgroundT;
  return backgroundT && 'var(--color-base-transparent)';
});
exports.Occ_Header = Occ_Header;
var Occ_HeaderImg = (0, _styledComponents["default"])('img')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 30px;\n"])));
exports.Occ_HeaderImg = Occ_HeaderImg;
var Occ_HeaderButton = (0, _styledComponents["default"])('button')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    position: ", ";\n    left: ", ";\n\n    svg {\n        color: var(--color-primary);\n        font-size: var(--font-size-lg);\n    }\n\n    &:focus {\n        outline: transparent;\n    }\n"])), function (props) {
  return props.htype === 'backTitle' && 'absolute';
}, function (props) {
  return props.htype === 'backTitle' && '10px';
});
exports.Occ_HeaderButton = Occ_HeaderButton;
var Occ_HeaderBackTitleContainer = (0, _styledComponents["default"])('div')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n"])));
exports.Occ_HeaderBackTitleContainer = Occ_HeaderBackTitleContainer;